// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailsItem_container__1Vvqa","label":"DetailsItem_label__LN8tN"};